import api from "./api"

export const cardService = {
    getCards: async () => {
        try {
            const response = await api.get('api/Card');
            return response.data;
        } catch (error) {
            const status = error.response?.status;
            const message = error.response?.data?.message || error.response?.data || error.message;
            throw new Error(`Erro ao buscar os cards [${status}]: ${JSON.stringify(message)}`);
        }
    },
    getCard: async (numCard) => {
        try {
            const response = await api.get(`api/Card/${numCard}`);
            return response.data;
        } catch (error) {
            const status = error.response?.status;
            const message = error.response?.data?.message || error.response?.data || error.message;
            throw new Error(`Erro ao buscar o card [${status}]: ${JSON.stringify(message)}`);
        }
    },
    // ── NOVO ─────────────────────────────────────────────────────────────────
    getCardsByColumn: async (numColumn) => {
        try {
            const response = await api.get(`api/Card/by-column/${numColumn}`);
            return response.data;
        } catch (error) {
            const status = error.response?.status;
            const message = error.response?.data?.message || error.response?.data || error.message;
            throw new Error(`Erro ao buscar cards da coluna [${status}]: ${JSON.stringify(message)}`);
        }
    },
    // ─────────────────────────────────────────────────────────────────────────
    createCard: async (numColumn, title, description) => {
        try {
            const response = await api.post('api/Card', {
                numColumn,
                title,
                description,
            });
            return response.data;
        } catch (error) {
            const status = error.response?.status;
            const message = error.response?.data?.message || error.response?.data || error.message;
            throw new Error(`Erro ao criar o card [${status}]: ${JSON.stringify(message)}`);
        }
    },
    updateCard: async (numCard, numColumn, title, description, ativo) => {
        try {
            const response = await api.put(`api/Card/${numCard}`, {
                numCard,
                numColumn,
                title,
                description,
                ativo,
            });
            return response.data;
        } catch (error) {
            const status = error.response?.status;
            const message = error.response?.data?.message || error.response?.data || error.message;
            throw new Error(`Erro ao atualizar o card [${status}]: ${JSON.stringify(message)}`);
        }
    },
        deleteCard: async (card) => {
        try {
            const response = await api.put(`api/Card/${card.numCard}`, {
                numCard: card.numCard,
                numColumn: card.numColumn,
                title: card.title,
                description: card.description,
                ativo: false,
            });
            return response.data;
        } catch (error) {
            const status = error.response?.status;
            const message = error.response?.data?.message || error.response?.data || error.message;
            throw new Error(`Erro ao deletar o card [${status}]: ${JSON.stringify(message)}`);
        }
    },
};
